import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionConditionTypeEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link PaymentScenarionConditionTypeEnum} enumeration values */
export const PaymentScenarionConditionTypeEnumI18n: EnumI18nInterface<PaymentScenarionConditionTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [PaymentScenarionConditionTypeEnum.BIGGER_THAN]: 'Больше',
    [PaymentScenarionConditionTypeEnum.EQUAL]: 'Равно',
    [PaymentScenarionConditionTypeEnum.LOWER_THAN]: 'Меньше',
    [PaymentScenarionConditionTypeEnum.NONE]: 'Условие без знака',
  },
  [I18nLocalesEnum.EN_US]: {
    [PaymentScenarionConditionTypeEnum.BIGGER_THAN]: 'Bigger',
    [PaymentScenarionConditionTypeEnum.EQUAL]: 'Equal',
    [PaymentScenarionConditionTypeEnum.LOWER_THAN]: 'Lower',
    [PaymentScenarionConditionTypeEnum.NONE]: 'Without a sign',
  },
};
